import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthToken, getUserData } from '../utils/authUtils';
import { useAuth } from '../context/AuthContext'; // Import the useAuth hook
import { useMsal } from '@azure/msal-react';

const ProtectedRoute = ({ children }) => {
  const token = getAuthToken();
  const { accounts, inProgress } = useMsal();

  const isMsalLoggedIn = accounts.length > 0;
  const isNormalLoggedIn = !!token;

  // 🔥 FIRST: wait for MSAL to finish
  if (inProgress !== "none") {
    return null; // or loader
  }

  // 🔥 THEN: check both auth types
  if (isMsalLoggedIn || isNormalLoggedIn) {
    return children;
  }

  // Otherwise redirect
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;